<template>
    <div class="row">
        <div class="text-center" :class="{'col-3': !IsPaymentSettled, 'col-12': IsPaymentSettled}">
            <div class="text-capitalize" :class="{ 'font-weight-bold': IsPembayaran }">{{ HeadlineText }}</div>
        </div>
        <template v-if="!IsPaymentSettled">
            <div class="col-5">
                <VMultiSelect class="tipe_surat" ref="RefTipeSurat" v-model="SelectedTipeSurat" :options="ListTipeSurat"
                    :label="LabelMultiSelect" :track-by="TrackByMultiSelect" :disabled="CurrentlyComposeLetter" />
            </div>
            <div class="col-4">
                <template v-if="!CurrentlyComposeLetter">
                    <button class="btn text-capitalize"
                        :class="{ 'btn-dark': DisabledBtnTambahSurat, 'btn-success': !DisabledBtnTambahSurat }"
                        :disabled="DisabledBtnTambahSurat" @click="ProxyAddLetter">
                        tambah surat
                    </button>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
    name: 'SuratPenunjangBasic',
    components: { VMultiSelect: () => import('vue-multiselect') },
    props: {
        IsPembayaran: {
            type: Boolean,
            default: false
        },
        IsPaymentSettled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            SelectedTipeSurat: null,
            ListTipeSurat: [],
            LabelMultiSelect: 'nama_tipe_surat',
            TrackByMultiSelect: 'id',
        }
    },
    watch: {
        CurrentlyComposeLetter(newVal, oldVal) {
            if (!newVal) {
                this.SelectedTipeSurat = null;
            }
        },
    },
    async mounted() {
        if (!this.IsPaymentSettled) {
            this.$nextTick(async () => {
                await this.FetchTypeOfSuratPenunjang();
            })
        }
    },
    computed: {
        ...mapGetters('SuratPenunjangStore', ['API_URL']),
        ...mapState('SuratPenunjangStore', ['CurrentlyComposeLetter']),
        DisabledBtnTambahSurat() {
            return this.SelectedTipeSurat === null;
        },
        HeadlineText() {
            return this.IsPembayaran ? 'surat penunjang' : 'tipe surat:'
        }
    },
    methods: {
        ...mapMutations('SuratPenunjangStore', ['SetLetterMutation', 'SetLetterTypeMutation']),
        SetFocusRefTipeSurat() {
            if (this.$refs.RefTipeSurat) {
                this.$refs.RefTipeSurat.activate();
            }
        },
        async FetchTypeOfSuratPenunjang() {
            try {
                const { data } = await this.$axios.get(`${this.API_URL}/tipe-surat`)
                this.ListTipeSurat = data
            } catch (err) {
                console.log('failed to fetch type of surat penunjang')
            } finally {
                this.$emit('DoneLoadingBasic')
            }
        },
        ProxyAddLetter() {
            this.SetLetterTypeMutation(this.SelectedTipeSurat.nama_tipe_surat)
            this.SetLetterMutation(true)
        }
    }
}
</script>